import api from 'school-space-client/api';

const start = () => api.configure({ baseUrl: process.env.REACT_APP_API_URL });

export default { start, service: api };
